import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { Invoice } from 'src/app/interfaces/models/invoice';

import { BaseModel } from './base-model';
import { Company } from './company';
import { CompanyFee } from './company-fee';
import { Transaction } from './transaction';
import { Vendor } from './vendor';

export class CompanyVendorPayment extends BaseModel {
  static CompanyVendorPaymentProperties: (
    | {
        property: keyof CompanyVendorPayment;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyVendorPayment;
        type: 'alias';
      }
    | {
        property: keyof CompanyVendorPayment;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyVendorId', type: 'column', dataType: 'number' },
    { property: 'InvoiceId', type: 'column', dataType: 'number' },
    { property: 'priorityLevel', type: 'column', dataType: 'number' },
    { property: 'feeType', type: 'column', dataType: 'string' },
    { property: 'feeAmt', type: 'column', dataType: 'number' },
    { property: 'paidAmt', type: 'column', dataType: 'number' },
    { property: 'remittanceAmt', type: 'column', dataType: 'number' },
    { property: 'discountAmt', type: 'column', dataType: 'number' },
    { property: 'expDate', type: 'column', dataType: 'date' },
    { property: 'expStatus', type: 'column', dataType: 'string' },
    { property: 'isBlockedPayment', type: 'column', dataType: 'boolean' },
    { property: 'isProrated', type: 'column', dataType: 'boolean' },
    { property: 'CompanyFeeId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'clientNames', type: 'alias' },
    { property: 'paymentStatus', type: 'alias' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'Company', model: 'Company', type: 'association' },
    { property: 'Invoice', model: 'Invoice', type: 'association' },
    { property: 'CompanyFee', model: 'CompanyFee', type: 'association' },
    { property: 'Transactions', model: 'Transaction', type: 'association' }
  ];

  static {
    CompanyVendorPayment.CompanyVendorPaymentProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyVendorPayment.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyVendorPayment.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyVendorPayment.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(CompanyVendorPaymentObject: Partial<CompanyVendorPayment>) {
    super();

    CompanyVendorPayment.CompanyVendorPaymentProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyVendorPaymentObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyId?: number | null;
  VendorId?: number | null;
  CompanyVendorId?: number | null;
  InvoiceId?: number;
  priorityLevel?: number;
  feeType?: 'BASE' | 'RENEWAL' | 'MULTICLIENT' | 'PREFERRED';
  feeAmt?: number;
  paidAmt?: number;
  remittanceAmt?: number;
  discountAmt?: number;
  expDate?: Date | null;
  expStatus?:
    | '12M'
    | 'VALID'
    | '30D'
    | '15D'
    | '10D'
    | '5D'
    | '1D'
    | 'EXPIRED'
    | 'REPLACED';
  isBlockedPayment?: boolean;
  isProrated?: boolean;
  CompanyFeeId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  //Aliased column(s)
  clientNames?: string;
  paymentStatus?: string;

  Vendor?: Vendor;
  Company?: Company;
  Invoice?: Invoice;
  CompanyFee?: CompanyFee;
  Transactions?: Transaction[];
}
